import React, { Fragment, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { BoundedSearch, CheckBold, CheckGroup, LeftButton, RightButton } from '../styled/form';
import { HR, ShadowBox, ShiftShadowBox } from '../styled/layout';
import { filter } from '../util';
// Just enough width to prevent borders from the underlying Dropdown from showing
const OverlayBox = styled(ShiftShadowBox) `
  width: 305px;
`;
const allChecked = (options, selected) => !!selected.length &&
    options.filter(o => !o.disabled).map(o => o.value).length === selected.length;
export const MultiSelectOverlay = ({ displayName, onConfirm, onSelect, onReset, options, selected = [], showAll, showSearch, shifted, style, visible }) => {
    const [all, setAll] = useState(allChecked(options, selected));
    const [search, setSearch] = useState('');
    const filteredOptions = filter(search, options);
    let input;
    if (showSearch) {
        const searchInput = useRef(null);
        useEffect(() => {
            var _a;
            if (visible) {
                (_a = searchInput.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }, [visible, searchInput.current]);
        const onSearch = (e) => setSearch(e.target.value || '');
        input = (React.createElement(BoundedSearch, { ref: searchInput, onChange: onSearch, placeholder: `Search ${displayName}`, value: search }));
    }
    useEffect(() => {
        setAll(allChecked(options, selected));
    }, [selected]);
    const onCheckAll = (e) => {
        setAll(e.target.checked);
        const values = e.target.checked
            ? options.filter(o => !o.disabled).map(o => o.value)
            : [];
        onSelect(values);
    };
    const reset = e => {
        setSearch('');
        onReset(e);
    };
    const hasDisabledOptions = options.some(o => o.disabled);
    const indeterminate = !!selected.length && !allChecked(options, selected);
    const Container = shifted ? OverlayBox : ShadowBox;
    return (React.createElement(Container, { style: style || {} },
        showSearch && input,
        showAll && !search.length && (React.createElement(CheckBold, { checked: all, indeterminate: indeterminate, onChange: onCheckAll }, `All ${hasDisabledOptions ? 'remaining ' : ''}${displayName}`)),
        React.createElement(CheckGroup, { onChange: onSelect, options: filteredOptions, value: selected }),
        React.createElement(HR, null),
        React.createElement(Fragment, null,
            React.createElement(LeftButton, { onClick: reset, size: "small", type: "link" }, "Reset"),
            React.createElement(RightButton, { onClick: onConfirm, size: "small", type: "link" }, "OK"))));
};
export default MultiSelectOverlay;
